import { useUserStore } from '@/entities/user/store';

export default defineNuxtRouteMiddleware((to) => {
  const PROFILE_PATH = '/cabinet/profile';
  if (to.path.startsWith(PROFILE_PATH) || to.path.includes('legal')) return;

  const userStore = useUserStore();
  const user = userStore.user;

  if (userStore.isAuth && user && (!user.email || !user.name)) {
    return navigateTo(PROFILE_PATH);
  }
});
